import { LanguageOption } from "../components/LanguageSelectorComponent";

export const SUPPORTED_GENERATION_LANGUAGES = [
  {
    label: "Afrikaans",
    local_name: "Afrikaans",
    defaultCode: "af",
    flag: "🇿🇦",
    variants: ["af-ZA"],
  },
  {
    label: "Albanian",
    local_name: "Shqip",
    defaultCode: "sq",
    flag: "🇦🇱",
    variants: ["sq-AL", "sq-XK"],
  },
  {
    label: "Amharic",
    local_name: "አማርኛ",
    defaultCode: "am",
    flag: "🇪🇹",
    variants: ["am-ET"],
  },
  {
    label: "Arabic",
    local_name: "العربية",
    defaultCode: "ar",
    flag: "🇸🇦",
    variants: ["ar-SA", "ar-EG", "ar-AE", "ar-MA", "ar-LB"],
  },
  {
    label: "Armenian",
    local_name: "Հայերեն",
    defaultCode: "hy",
    flag: "🇦🇲",
    variants: ["hy-AM"],
  },
  {
    label: "Basque",
    local_name: "Euskara",
    defaultCode: "eu",
    flag: "🏳️",
    variants: ["eu-ES"],
  },
  {
    label: "Belarusian",
    local_name: "Беларуская",
    defaultCode: "be",
    flag: "🇧🇾",
    variants: ["be-BY"],
  },
  {
    label: "Bengali",
    local_name: "বাংলা",
    defaultCode: "bn",
    flag: "🇧🇩",
    variants: ["bn-BD", "bn-IN"],
  },
  {
    label: "Bulgarian",
    local_name: "Български",
    defaultCode: "bg",
    flag: "🇧🇬",
    variants: ["bg-BG"],
  },
  {
    label: "Catalan",
    local_name: "Català",
    defaultCode: "ca",
    flag: "🇪🇸",
    variants: ["ca-ES"],
  },
  {
    label: "Chinese",
    local_name: "中文",
    defaultCode: "zh",
    flag: "🇨🇳",
    variants: ["zh-CN", "zh-TW", "zh-HK", "zh-SG"],
  },
  {
    label: "Croatian",
    local_name: "Hrvatski",
    defaultCode: "hr",
    flag: "🇭🇷",
    variants: ["hr-HR"],
  },
  {
    label: "Czech",
    local_name: "Čeština",
    defaultCode: "cs",
    flag: "🇨🇿",
    variants: ["cs-CZ"],
  },
  {
    label: "Danish",
    local_name: "Dansk",
    defaultCode: "da",
    flag: "🇩🇰",
    variants: ["da-DK"],
  },
  {
    label: "Dutch",
    local_name: "Nederlands",
    defaultCode: "nl",
    flag: "🇳🇱",
    variants: ["nl-NL", "nl-BE"],
  },
  {
    label: "English",
    local_name: "English",
    defaultCode: "en",
    flag: "🇬🇧",
    variants: ["en-US", "en-GB", "en-AU", "en-NZ", "en-IN", "en-CA"],
  },
  {
    label: "Esperanto",
    local_name: "Esperanto",
    defaultCode: "eo",
    flag: "🏳️",
    variants: [],
  },
  {
    label: "Estonian",
    local_name: "Eesti",
    defaultCode: "et",
    flag: "🇪🇪",
    variants: ["et-EE"],
  },
  {
    label: "Farsi",
    local_name: "فارسی",
    defaultCode: "fa",
    flag: "🇮🇷",
    variants: ["fa-IR"],
  },
  {
    label: "French",
    local_name: "Français",
    defaultCode: "fr",
    flag: "🇫🇷",
    variants: ["fr-FR", "fr-CA", "fr-BE", "fr-CH", "fr-LU"],
  },
  {
    label: "FYRO Macedonian",
    local_name: "Македонски",
    defaultCode: "mk",
    flag: "🇲🇰",
    variants: ["mk-MK"],
  },
  {
    label: "Gaelic",
    local_name: "Gàidhlig",
    defaultCode: "gd",
    flag: "🏳️",
    variants: ["gd-GB"],
  },
  {
    label: "Georgian",
    local_name: "ქართული",
    defaultCode: "ka",
    flag: "🇬🇪",
    variants: ["ka-GE"],
  },
  {
    label: "German",
    local_name: "Deutsch",
    defaultCode: "de",
    flag: "🇩🇪",
    variants: ["de-DE", "de-AT", "de-CH", "de-LU", "de-LI"],
  },
  {
    label: "Greek",
    local_name: "Ελληνικά",
    defaultCode: "el",
    flag: "🇬🇷",
    variants: ["el-GR"],
  },
  {
    label: "Gujarati",
    local_name: "ગુજરાતી",
    defaultCode: "gu",
    flag: "🇮🇳",
    variants: ["gu-IN"],
  },
  {
    label: "Hausa",
    local_name: "Hausa",
    defaultCode: "ha",
    flag: "🇳🇬",
    variants: ["ha-NG"],
  },
  {
    label: "Hebrew",
    local_name: "עברית",
    defaultCode: "he",
    flag: "🇮🇱",
    variants: ["he-IL"],
  },
  {
    label: "Hindi",
    local_name: "हिन्दी",
    defaultCode: "hi",
    flag: "🇮🇳",
    variants: ["hi-IN"],
  },
  {
    label: "Hungarian",
    local_name: "Magyar",
    defaultCode: "hu",
    flag: "🇭🇺",
    variants: ["hu-HU"],
  },
  {
    label: "Icelandic",
    local_name: "Íslenska",
    defaultCode: "is",
    flag: "🇮🇸",
    variants: ["is-IS"],
  },
  {
    label: "Indonesian",
    local_name: "Bahasa Indonesia",
    defaultCode: "id",
    flag: "🇮🇩",
    variants: ["id-ID"],
  },
  {
    label: "Irish",
    local_name: "Gaeilge",
    defaultCode: "ga",
    flag: "🇮🇪",
    variants: ["ga-IE"],
  },
  {
    label: "Italian",
    local_name: "Italiano",
    defaultCode: "it",
    flag: "🇮🇹",
    variants: ["it-IT", "it-CH"],
  },
  {
    label: "Japanese",
    local_name: "日本語",
    defaultCode: "ja",
    flag: "🇯🇵",
    variants: ["ja-JP"],
  },
  {
    label: "Kannada",
    local_name: "ಕನ್ನಡ",
    defaultCode: "kn",
    flag: "🇮🇳",
    variants: ["kn-IN"],
  },
  {
    label: "Kazakh",
    local_name: "Қазақ",
    defaultCode: "kk",
    flag: "🇰🇿",
    variants: ["kk-KZ"],
  },
  {
    label: "Kinyarwanda",
    local_name: "Kinyarwanda",
    defaultCode: "rw",
    flag: "🇷🇼",
    variants: ["rw-RW"],
  },
  {
    label: "Kirghiz",
    local_name: "Кыргызча",
    defaultCode: "ky",
    flag: "🇰🇬",
    variants: ["ky-KG"],
  },
  {
    label: "Korean",
    local_name: "한국어",
    defaultCode: "ko",
    flag: "🇰🇷",
    variants: ["ko-KR"],
  },
  {
    label: "Latin",
    local_name: "Latina",
    defaultCode: "la",
    flag: "🏳️",
    variants: [],
  },
  {
    label: "Latvian",
    local_name: "Latviešu",
    defaultCode: "lv",
    flag: "🇱🇻",
    variants: ["lv-LV"],
  },
  {
    label: "Lithuanian",
    local_name: "Lietuvių",
    defaultCode: "lt",
    flag: "🇱🇹",
    variants: ["lt-LT"],
  },
  {
    label: "Malagasy",
    local_name: "Malagasy",
    defaultCode: "mg",
    flag: "🇲🇬",
    variants: ["mg-MG"],
  },
  {
    label: "Malay",
    local_name: "Bahasa Melayu",
    defaultCode: "ms",
    flag: "🇲🇾",
    variants: ["ms-MY", "ms-SG"],
  },
  {
    label: "Malayalam",
    local_name: "മലയാളം",
    defaultCode: "ml",
    flag: "🇮🇳",
    variants: ["ml-IN"],
  },
  {
    label: "Maltese",
    local_name: "Malti",
    defaultCode: "mt",
    flag: "🇲🇹",
    variants: ["mt-MT"],
  },
  {
    label: "Marathi",
    local_name: "मराठी",
    defaultCode: "mr",
    flag: "🇮🇳",
    variants: ["mr-IN"],
  },
  {
    label: "Nepali (India)",
    local_name: "नेपाली (भारत)",
    defaultCode: "ne",
    flag: "🇳🇵",
    variants: ["ne-NP", "ne-IN"],
  },
  {
    label: "Norwegian",
    local_name: "Norsk",
    defaultCode: "no",
    flag: "🇳🇴",
    variants: ["nn-NO", "nb-NO"],
  },
  {
    label: "Occitan",
    local_name: "Occitan",
    defaultCode: "oc",
    flag: "🏳️",
    variants: ["oc-FR"],
  },
  {
    label: "Polish",
    local_name: "Polski",
    defaultCode: "pl",
    flag: "🇵🇱",
    variants: ["pl-PL"],
  },
  {
    label: "Portuguese",
    local_name: "Português",
    defaultCode: "pt",
    flag: "🇵🇹",
    variants: ["pt-PT", "pt-BR"],
  },
  {
    label: "Punjabi",
    local_name: "ਪੰਜਾਬੀ",
    defaultCode: "pa",
    flag: "🇮🇳",
    variants: ["pa-IN", "pa-PK"],
  },
  {
    label: "Romanian",
    local_name: "Română",
    defaultCode: "ro",
    flag: "🇷🇴",
    variants: ["ro-RO", "ro-MD"],
  },
  {
    label: "Russian",
    local_name: "Русский",
    defaultCode: "ru",
    flag: "🇷🇺",
    variants: ["ru-RU", "ru-BY", "ru-KZ", "ru-UA"],
  },
  {
    label: "Samoan",
    local_name: "Samoan",
    defaultCode: "sm",
    flag: "🇼🇸",
    variants: ["sm-WS"],
  },
  {
    label: "Sanskrit",
    local_name: "Sanskrit",
    defaultCode: "sa",
    flag: "🇮🇳",
    variants: ["sa-IN"],
  },
  {
    label: "Serbian",
    local_name: "Српски",
    defaultCode: "sr",
    flag: "🇷🇸",
    variants: ["sr-RS", "sr-BA", "sr-ME"],
  },
  {
    label: "Serbo-Croatian",
    local_name: "Srpskohrvatski",
    defaultCode: "sh",
    flag: "🇷🇸",
    variants: ["sh-BA", "sh-HR", "sh-ME", "sh-RS"],
  },
  {
    label: "Sesotho",
    local_name: "Sesotho",
    defaultCode: "st",
    flag: "🇱🇸",
    variants: ["st-LS"],
  },
  {
    label: "Siswati",
    local_name: "SiSwati",
    defaultCode: "ss",
    flag: "🇸🇿",
    variants: ["ss-SZ"],
  },
  {
    label: "Slovak",
    local_name: "Slovenčina",
    defaultCode: "sk",
    flag: "🇸🇰",
    variants: ["sk-SK"],
  },
  {
    label: "Slovenian",
    local_name: "Slovenščina",
    defaultCode: "sl",
    flag: "🇸🇮",
    variants: ["sl-SI"],
  },
  {
    label: "Spanish",
    local_name: "Español",
    defaultCode: "es",
    flag: "🇪🇸",
    variants: ["es-ES", "es-MX", "es-AR", "es-CO", "es-US", "es-CL"],
  },
  {
    label: "Swahili",
    local_name: "Kiswahili",
    defaultCode: "sw",
    flag: "🇹🇿",
    variants: ["sw-TZ", "sw-KE", "sw-UG"],
  },
  {
    label: "Swedish",
    local_name: "Svenska",
    defaultCode: "sv",
    flag: "🇸🇪",
    variants: ["sv-SE", "sv-FI"],
  },
  {
    label: "Tagalog",
    local_name: "Tagalog",
    defaultCode: "tl",
    flag: "🇵🇭",
    variants: ["tl-PH"],
  },
  {
    label: "Tajik",
    local_name: "Тоҷикӣ",
    defaultCode: "tg",
    flag: "🇹🇯",
    variants: ["tg-TJ"],
  },
  {
    label: "Tamil",
    local_name: "தமிழ்",
    defaultCode: "ta",
    flag: "🇮🇳",
    variants: ["ta-IN", "ta-LK", "ta-SG", "ta-MY"],
  },
  {
    label: "Tatar",
    local_name: "Tatarça",
    defaultCode: "tt",
    flag: "🇷🇺",
    variants: ["tt-RU"],
  },
  {
    label: "Telugu",
    local_name: "తెలుగు",
    defaultCode: "te",
    flag: "🇮🇳",
    variants: ["te-IN"],
  },
  {
    label: "Turkish",
    local_name: "Türkçe",
    defaultCode: "tr",
    flag: "🇹🇷",
    variants: ["tr-TR"],
  },
  {
    label: "Ukrainian",
    local_name: "Українська",
    defaultCode: "uk",
    flag: "🇺🇦",
    variants: ["uk-UA"],
  },
  {
    label: "Welsh",
    local_name: "Cymraeg",
    defaultCode: "cy",
    flag: "🏳️",
    variants: ["cy-GB"],
  },
  {
    label: "Yoruba",
    local_name: "Yoruba",
    defaultCode: "yo",
    flag: "🇳🇬",
    variants: ["yo-NG"],
  },
];

// Nova 2 supported languages and variants
export const DEEPGRAM_NOVA_LANGUAGES: LanguageOption[] = [
  { label: "English", defaultCode: "en", variants: ["en-US", "en-GB", "en-AU", "en-NZ", "en-IN"], flag: "🇺🇸" },
  { label: "Spanish", defaultCode: "es", variants: ["es-419"], flag: "🇪🇸" },
  { label: "French", defaultCode: "fr", variants: ["fr-CA"], flag: "🇫🇷" },
  { label: "German", defaultCode: "de", variants: ["de-CH"], flag: "🇩🇪" },
  { label: "Italian", defaultCode: "it", flag: "🇮🇹" },
  { label: "Portuguese", defaultCode: "pt", variants: ["pt-BR"], flag: "🇵🇹" },
  { label: "Dutch", defaultCode: "nl", variants: ["nl-BE"], flag: "🇳🇱" },
  { label: "Russian", defaultCode: "ru", flag: "🇷🇺" },
  { label: "Polish", defaultCode: "pl", flag: "🇵🇱" },
  { label: "Ukrainian", defaultCode: "uk", flag: "🇺🇦" },
  { label: "Czech", defaultCode: "cs", flag: "🇨🇿" },
  { label: "Bulgarian", defaultCode: "bg", flag: "🇧🇬" },
  { label: "Romanian", defaultCode: "ro", flag: "🇷🇴" },
  { label: "Hungarian", defaultCode: "hu", flag: "🇭🇺" },
  { label: "Greek", defaultCode: "el", flag: "🇬🇷" },
  { label: "Swedish", defaultCode: "sv", variants: ["sv-SE"], flag: "🇸🇪" },
  { label: "Norwegian", defaultCode: "no", flag: "🇳🇴" },
  { label: "Danish", defaultCode: "da", variants: ["da-DK"], flag: "🇩🇰" },
  { label: "Finnish", defaultCode: "fi", flag: "🇫🇮" },
  { label: "Catalan", defaultCode: "ca", flag: "🇦🇩" },
  { label: "Turkish", defaultCode: "tr", flag: "🇹🇷" },
  { label: "Estonian", defaultCode: "et", flag: "🇪🇪" },
  { label: "Latvian", defaultCode: "lv", flag: "🇱🇻" },
  { label: "Lithuanian", defaultCode: "lt", flag: "🇱🇹" },
  { label: "Slovak", defaultCode: "sk", flag: "🇸🇰" },
  { label: "Chinese", defaultCode: "zh", variants: ["zh-CN", "zh-TW", "zh-Hans", "zh-Hant"], flag: "🇨🇳" },
  { label: "Japanese", defaultCode: "ja", flag: "🇯🇵" },
  { label: "Korean", defaultCode: "ko", variants: ["ko-KR"], flag: "🇰🇷" },
  { label: "Hindi", defaultCode: "hi", flag: "🇮🇳" },
  { label: "Thai", defaultCode: "th", variants: ["th-TH"], flag: "🇹🇭" },
  { label: "Vietnamese", defaultCode: "vi", flag: "🇻🇳" },
  { label: "Indonesian", defaultCode: "id", flag: "🇮🇩" },
  { label: "Malay", defaultCode: "ms", flag: "🇲🇾" },
];
